<div class="row page-header">
    <div class="col-12">
        <h1>Punch List <small>Track punch list items by job</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row" style="margin-bottom: 10px">
        <div class="col-12">
            <form class="form-inline">
                <wj-combo-box
                    [(ngModel)]="selectedJob"
                    name="selectedJob"
                    (ngModelChange)="onJobChanged()"
                    style="width: 400px"
                    [itemsSource]="jobMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </form>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="!selectedJob() || selectedJob() === ''">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canToggleDone"
                            [showAdd]="canEdit"
                            [showEdit]="true"
                            [showDelete]="canEdit"
                            [showDuplicate]="false"
                        ></action-toolbar-buttons>
                        @if (canEdit) {
                            <button type="button" class="btn btn-sm btn-secondary ms-2" (click)="openImportModal()">
                                Import (AI)
                            </button>
                        }
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Punch List'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="25"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Item'"
                            [binding]="'item'"
                            [width]="70"
                            [format]="'n0'"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Location'" [binding]="'location'" [width]="160"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Priority'"
                            [binding]="'priority'"
                            [width]="90"
                            [format]="'n0'"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Project PL#'" [binding]="'projectMateNumber'" [width]="110"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [minWidth]="200"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'VanCon Responsible'"
                            [binding]="'vanConResponsibleUserId'"
                            [width]="180"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Non-VanCon Firm Responsible'"
                            [binding]="'responsibleFirmId'"
                            [width]="220"
                            [dataMap]="firmDisplayMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contact'"
                            [binding]="'contactId'"
                            [width]="180"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Done'"
                            [binding]="'done'"
                            [width]="80"
                            [dataMap]="doneMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Notes'"
                            [binding]="'notes'"
                            [minWidth]="160"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Recipient Comment'"
                            [binding]="'completionComment'"
                            [width]="220"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="selectedJob() && selectedJob() !== ''">
        <div class="col-12">
            <p>Please select a project from the dropdown above.</p>
        </div>
    </div>
</div>
